<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="image"

      src="@/assets/Diseño sin título (42).png"
      alt="Imagen de ejemplo"
      class="cover-image"
    >
    <div class="overlay"></div>
    
   
    <div ref="textRef" class="text-overlay"> <!-- Texto elegante sobre la imagen 
      <p class="subtitle">
        Te espero para que formes parte de uno de los mejores días de mi vida.
      </p>--><br>
      <p class="firma">
        Con cariño,<br>
        <span>Kimberly

</span>
      </p>
    </div>
  </div>
</template>
<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const imageContainer = ref(null)

    onMounted(() => {

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: imageContainer.value,
          start: 'top 75%',   // 👈 entra cuando YA lo ves
          once: true
        }
      })

      /* 🖼️ IMAGEN — ENTRA MUY ZOOM + ALTA */
      tl.fromTo(
        image.value,
        {
          opacity: 0,
          scale: 1.35,     // 🔥 ZOOM FUERTE
          scaleY: 1.5,     // 🔥 MÁS ALTURA
          y: 80            // 🔥 viene desde abajo
        },
        {
          opacity: 1,
          scale: 1,
          scaleY: 1,
          y: 0,
          duration: 2,
          ease: 'power4.out'
        }
      )

      /* ✨ FIRMA — CLARAMENTE DESPUÉS */
      tl.fromTo(
        textRef.value,
        {
          opacity: 0,
          y: 60
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.4,
          ease: 'power3.out'
        },
        '+=0.6' // 👈 pausa visible
      )
    })

    return { textRef, image, imageContainer }
  }
}
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 590px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(70%);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.text-overlay {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
  color: hsl(0, 0%, 100%);
    bottom: 27px;          /* 👈 MÁS ABAJO */

  z-index: 10;
  opacity: 0;
    transform: translateY(27px); /* 👈 baja sin salir del contenedor */

  padding: 0 20px;
}

.subtitle {
  font-size: 20px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 15px;
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: 15px !important;
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 46px !important;  font-size: 2rem;
  color: #fff;
}
</style>
